<template>
    <div class="hundred_percent_form left_form">
        <el-form :label-position="labelPosition" v-loading="loading" :rules="formRules" ref="dataForm" :model="form" label-width="200px">
            <el-form-item label="订单兑换比率" prop="userintegralrate">
                <el-input style="width: 160px;" type="test" v-model="form.userintegralrate" clearable><template slot="append">%</template></el-input>
            </el-form-item>
            <el-form-item label="1$ =" prop="userintegralratio">
                <el-input style="width: 160px;" type="test" v-model="form.userintegralratio" clearable><template slot="append">积分</template></el-input>
            </el-form-item>
            <el-form-item label="订单总额获赠积分比率" prop="userintegralpen">
                <el-input style="width: 160px;" type="test" v-model="form.userintegralpen" clearable><template slot="append">%</template></el-input>
            </el-form-item>
            <el-form-item label="下级订单总额获赠积分比率" prop="userintegralsub">
                <el-input style="width: 160px;" type="test" v-model="form.userintegralsub" clearable><template slot="append">%</template></el-input>
            </el-form-item>
            <el-form-item label="邀请用户获得积分数" prop="userintegralinvite">
                <el-input style="width: 160px;" type="test" v-model="form.userintegralinvite" clearable><template slot="append">积分</template></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="formSubmit" :loading="formLoading">保 存</el-button>
                <el-button @click="onCancel">取 消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import { getInfo, update } from "../../api/setting/sysUserIntegral";
    export default {
        data() {
            var checkRate = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('订金兑换比率不能为空'));
                } else {
                    var reg = new RegExp("^([1-9]|[1-9]\\d|100)$");
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('请输入1-100的整数'));
                    }
                }
            };
            var checkRatio = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入积分数'));
                } else {
                    var reg = /^[1-9]\d*$/;
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('请输入大于0的正整数'));
                    }
                }
            };
            var checkPen = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入订单总额获赠积分比率'));
                } else {
                    var reg = new RegExp("^([1-9]|[1-9]\\d|100)$");
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('请输入1-100的整数'));
                    }
                }
            };
            var checkSub = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入下级订单总额获赠积分比率'));
                } else {
                    var reg = new RegExp("^([1-9]|[1-9]\\d|100)$");
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('请输入1-100的整数'));
                    }
                }
            };
            var checkInvite = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入邀请用户获得积分数'));
                } else {
                    var reg = /^[1-9]\d*$/;
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('请输入大于0的正整数'));
                    }
                }
            };
            return {
                loading: true,
                formLoading: false,
                form: {
                    userintegralrate: "",
                    userintegralratio: "",
                    userintegralpen: "",
                    userintegralsub: "",
                    userintegralinvite: "",
                    userintegralid:""
                },
                labelPosition: "left",
                formRules: {
                    userintegralrate: [{ validator: checkRate, trigger: "blur" }],
                    userintegralratio: [{ validator: checkRatio, trigger: "blur" }],
                    userintegralpen: [{ validator: checkPen, trigger: "blur" }],
                    userintegralsub: [{ validator: checkSub, trigger: "blur" }],
                    userintegralinvite: [{ validator: checkInvite, trigger: "blur" }],
                }
            };
        },
        methods: {
            onCancel() {
                this.getInfo();
                // 清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }
            },
            getInfo() {
                this.loading = true;
                getInfo()
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        if (response.data) {
                            this.form = response.data;
                        }
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {});
            },
            formSubmit() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        this.formLoading = true;
                        let data = Object.assign({}, this.form);
                        console.log(data);
                        update(data).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            //刷新表单
                            this.getInfo();
                            // 清空验证信息表单
                            if (this.$refs["dataForm"]) {
                                this.$refs["dataForm"].clearValidate();
                            }
                        });
                    }
                })
            }
        },
        created() {
            // 加载版本数据
            this.getInfo();
            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
        }
    };
</script>

<style type="text/scss" lang="scss">
    body {
        margin: 0;
    }
    .form {
        padding: 20px;
        width: 40%;
    }
    .title {
        color: #606266;
        text-align: center;
        font-size: 18px;
        margin: 30px 0;
    }
</style>
